<template>
  <div id="app">
    <b-container fluid>
      <b-row>
        <MobileNav
          :authenticated="authenticated"
          :isAdmin="isAdmin"
          :onMultipleProjects="onMultipleProjects"
          :isSponsor="isSponsor"
          :systemAdmin="isSystemAdmin"
        />

        <div class="sidebar-wrapper menu__desktop" :style="cssProps">
          <nav vertical :class="{ sidebar: true }">
            <header class="logo">
              <button class="toggle-sidebar" @click="toggleSidebar">
                <b-icon icon="list" class="open"></b-icon>
                <!--<span v-if="sidebarFull">Toggle sidebar</span>-->
              </button>
              <router-link to="/">
                <!--
                <img v-if="sidebarFull" src="./assets/logo/svg/caltrans-white.svg" class="logo img-fluid" alt="Caltrans Logo" />
                <img v-else src="./assets/logo/svg/caltrans-white-symbol.svg" class="logo img-fluid" alt="Caltrans Logo" />
                -->
                <img
                  v-if="sidebarFull && appLogo"
                  :src="appLogo"
                  class="logo img-fluid"
                  :alt="$store.getters.getContext.name + ' Logo'"
                />
              </router-link>
            </header>
            <ul class="sidebar-nav">
              <li
                v-if="authenticated && isAdmin && !onMultipleProjects && tenant"
                class="menu-item"
              >
                <router-link to="/project">
                  <b-icon icon="columns-gap"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Project</span>
                </router-link>
              </li>
              <!-- <li v-if="authenticated && isAdmin" class="menu-item">
                <router-link to="/dashboard">
                  <b-icon icon="columns-gap"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Dashboard</span>
                </router-link>
              </li>-->
              <li v-if="authenticated && isSponsor && tenant" class="menu-item">
                <router-link to="/overview">
                  <b-icon icon="columns-gap"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Overview</span>
                </router-link>
              </li>
              <li
                v-if="authenticated && (isSystemAdmin || (onMultipleProjects && isAdmin)) && tenant"
                class="menu-item menu-item-has-child"
              >
                <router-link to="/projects">
                  <b-icon icon="view-stacked"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Projects</span>
                </router-link>
                <!-- <ul v-if="sidebarFull" class="sub-menu">
                  <li class="menu-item">
                    <button>
                      <span class="labelName">Opened</span>
                    </button>
                  </li>
                  <li class="menu-item">
                    <button>
                      <span class="labelName">On Hold</span>
                    </button>
                  </li>
                  <li class="menu-item">
                    <button>
                      <span class="labelName">Closed</span>
                    </button>
                  </li>
                </ul>-->
              </li>
              <!--
              <li class="menu-item toggle">
                <router-link to="#">
                  <b-icon icon="envelope"></b-icon>
                </router-link>
              </li>-->
              <li v-if="authenticated && isSystemAdmin && tenant" class="menu-item off">
                <router-link to="/question-template/list">
                  <b-icon icon="question-circle"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Evaluations</span>
                </router-link>
              </li>
              <li v-if="authenticated && isSystemAdmin && tenant" class="menu-item off">
                <router-link to="/organization/list">
                  <b-icon icon="people"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Organizations</span>
                </router-link>
              </li>
              <li v-if="authenticated && isSystemAdmin && tenant" class="menu-item">
                <router-link to="/user/list">
                  <b-icon icon="person"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Users</span>
                </router-link>
              </li>
              <li v-if="authenticated && !tenant" class="menu-item">
                <router-link to="/choose-account">
                  <b-icon icon="person"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Choose Account</span>
                </router-link>
              </li>
              <!--
              <li class="menu-item toggle">
                <router-link to="#">
                  <b-icon icon="chat-left"></b-icon>
                </router-link>
              </li>
              <li class="menu-item toggle">
                <router-link to="#">
                  <b-icon icon="layout-three-columns"></b-icon>
                </router-link>
              </li>-->
              <hr />
              <!--<li class="menu-item toggle">
                <button>
                  <b-icon icon="three-dots"></b-icon>
                </button>
              </li>-->
              <li v-if="authenticated" class="menu-item off">
                <a href="https://www.youtube.com/channel/UCP2m2CYU6Ln47IGKCuvNm_g">
                  <b-icon icon="collection-play"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Help</span>
                </a>
              </li>
              <li v-if="authenticated" class="menu-item off">
                <router-link to="/user/settings">
                  <b-icon icon="gear"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Settings</span>
                </router-link>
              </li>
              <li v-if="!authenticated" class="menu-item">
                <router-link to="/login">
                  <b-icon icon="lock"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Login</span>
                </router-link>
              </li>
              <li v-if="authenticated" class="menu-item">
                <button @click.stop="logout">
                  <b-icon icon="door-open"></b-icon>
                  <span v-if="sidebarFull" class="labelName">Logout</span>
                </button>
              </li>
            </ul>
            <div class="by">
              <p v-if="sidebarFull" class="by-company">
                Powered by
                <img
                  src="./assets/logo/svg/dashtech-alt-logo.svg"
                  alt="DashTech Logo"
                  class="pb-logo"
                />
              </p>
              <p v-else class="by-company">
                <img
                  src="./assets/logo/svg/dashtech-symbol.svg"
                  alt="DashTech Logo"
                  class="pb-logo"
                />
              </p>
            </div>
          </nav>
        </div>
        <div class="app-wrapper" :style="cssProps">
          <b-navbar type="light" variant="white" class="user-bar">
            <b-navbar-nav class="ml-auto" v-if="authenticated">
              <b-nav-item>
                <router-link to="/user/settings">
                  <b-icon icon="gear">Settings</b-icon>
                </router-link>
              </b-nav-item>
              <!--
              <b-nav-item>
                <img src="./assets/avatar/avatar-6-104.jpg" class="thumbnail round img-fluid rounded-circle" alt="User Profile Thumbnail" />
              </b-nav-item>
              <li class="nav-item"><button class="notification"><b-icon icon="bell"></b-icon><b-icon icon="dot" class="notify"></b-icon><span class="sr-only">Notification</span></button></li>
              -->
            </b-navbar-nav>
          </b-navbar>
          <router-view :key="routerViewKey"></router-view>
        </div>
      </b-row>
      <LoginPopupModal
        ref="login-popup-modal"
        :responseId="responseId"
        :projectName="popupProjectName"
        :welcome="popupWelcome"
        :survey="popupSurvey"
        :surveyDay="popupSurveyDay"
      ></LoginPopupModal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import authMixin from "@/mixins/auth-mixin.js";
import LoginPopupModal from "@/modal-components/LoginPopupModal.vue";
import { mapGetters } from "vuex";
import LogRocket from "logrocket";

import MobileNav from "@/components/layout/MobileNav.vue";

export default {
  name: "app",
  components: {
    LoginPopupModal,
    MobileNav,
  },
  mixins: [authMixin],
  data() {
    return {
      version: "1.2.0",
      errors: [],
      sidebarFull: false,
      sidebarFullWidth: 195,
      sidebarMinWidth: 72,
      sending: false,
      windowWidth: window.innerWidth,
      upToDate: undefined, //We don't know if the app is up-to-date or not

      responseId: "",
      popupSurvey: false,
      popupWelcome: false,
      popupProjectName: null,
      popupSurveyDay: null,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.update().then(() => {
      this.interval = setInterval(() => this.update(), 60 * 1000);
    });
    this.handleResize();

    if (this.user) {
      // Adds user to logrocket if user vuex object exists
      LogRocket.identify(this.user.userId, {
        name: this.user.name,
        email: this.user.email,

        // Custom Logrocket Variables
        admin: this.user.admin,
        participant: this.user.participant,
        setup: this.user.setup,
        sponsor: this.user.sponsor,
        systemAdmin: this.user.systemAdmin,
      });
    }
  },
  methods: {
    stopWarningAboutIE() {
      let d = new Date();
      d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = "OkWithIE=true;" + expires + ";path=/";
      location.reload();
    },
    async update() {
      if (!this.$store.getters.getContext && this.$store.getters.getTenantId) {
        await this.getContext(this.$store.getters.getTenantId);
      }
      if (this.upToDate !== true) {
        this.verifyVersion(); // This doesn't need to be asyncronous
      }
      await this.verifyAuthentication();
      if (this.canShowPopup) {
        this.loginPopupCheck();
      }
    },
    async getContext(tenantId) {
      axios
        .get(
          `${this.$api_url}/tenants/${tenantId}/context`,
          this.getReqConfig()
        )
        .then((response) => {
          this.$store.dispatch("setContext", response.data);
        })
        .catch(() => {});
    },
    async verifyAuthentication() {
      let success = true;
      //If not logged in, don't bother
      if (!this.$store.getters.getAuthenticated) {
        return;
      }

      //Refresh the token if DashTech is the authenticator
      if (this.$store.getters.getAuthProvider === "DashTech") {
        let expiration = this.$store.getters.getTokenExpiration;
        if (
          localStorage.getItem("refreshToken") != null &&
          expiration != null
        ) {
          let expires = moment(expiration);
          let cutoff = expires.subtract(5, "minutes");
          const now = moment(new Date());

          if (now > cutoff || !this.$store.getters.getToken) {
            success = await this.refreshAuthDT(
              localStorage.getItem("refreshToken")
            );
          }
        } else {
          success = false;
        }
      } else if (this.$store.getters.getAuthProvider === "Microsoft") {
        let expiration = this.$store.getters.getTokenExpiration;
        if (expiration != null) {
          let expires = moment(expiration);
          let cutoff = expires.subtract(5, "minutes");
          const now = moment(new Date());
          if (now > cutoff || !this.$store.getters.getToken) {
            await this.refreshAuthMS();
          }
        }
      } else {
        success = false;
      }

      if (!success) {
        this.$auth.clearSession();
        this.$router.push({
          name: "Login",
          query: {
            message: "Your authentication has expired. Please re-log in.",
          },
        });
      }

      return success;
    },
    async refreshAuthDT(refreshToken) {
      return axios
        .post(
          `${this.$api_url}/identity/refresh`,
          {
            refreshToken: refreshToken,
          },
          this.getReqConfig()
        )
        .then(async (response) => {
          await this.initDashTechSession(response.data);
          return true;
        })
        .catch((err) => {
          console.error(err);
          return false;
        });
    },
    async refreshAuthMS() {
      this.$store.dispatch("setReturnUrl", window.location.pathname);
      return this.$authService
        .getToken()
        .then((response) => {
          if (response) {
            this.$store.dispatch("setToken", response.idToken);
            this.$store.dispatch("setTokenExpiration", response.expiresOn);
            this.$store.dispatch("setReturnUrl", "");
            return true;
          }
        })
        .catch((err) => {
          console.error(err);
          return false;
        });
    },
    verifyVersion() {
      axios
        .get(`${this.$api_url}/version`, this.getReqConfig())
        .then((response) => {
          if (response.data != this.version) {
            let lastRefresh = this.$store.getters.getRefreshTimer;
            let now = new Date();
            if (!lastRefresh || Math.abs(lastRefresh - now) > 1000 * 60 * 60) {
              this.$store.dispatch("setRefreshTimer", now);
              window.location.reload(true);
            }
          } else {
            this.upToDate = true;
            //console.log("Version is up to date");
          }
        });
    },
    toggleSidebar() {
      this.sidebarFull = !this.sidebarFull;
      window.dispatchEvent(new Event("resize"));
      //console.log(this.sidebarFull);
    },
    loginPopupCheck() {
      // Check if need for a welcome popup
      if (this.$route.query.signed_up) {
        this.popupWelcome = true;
        this.popupProjectName = this.$route.query.signed_up;
        this.popupSurveyDay = this.$route.query.survey_day;
      } else {
        this.popupWelcome = false;
        this.popupProjectName = this.$route.query.signed_up;
        this.popupSurveyDay = null;
      }
      
      //Check if the user has any outstanding surveys
      if (!this.sending) {
        this.sending = true;
        axios
          .get(
            `${this.$api_url}/users/${this.accountUser.userId}/survey-invitations?current_period=true`,
            this.getReqConfig()
          )
          .then((response) => {
            let invitations = response.data;
            let notCompletedSurveys = invitations.filter(
              (i) => i.hasResponded === false
            );

            if (notCompletedSurveys.length > 0 && this.$router.currentRoute.name !== "Survey") {
              this.responseId = notCompletedSurveys[0].responseId;
              this.popupSurvey = true;
            }

            if (this.popupWelcome || this.popupSurvey) {
              this.$nextTick(() => {
                this.$refs["login-popup-modal"].show();
              });
              //Mark that
              this.$store.dispatch("setLoginPopup", true);
            }
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768) {
        this.sidebarMinWidth = 0;
      } else {
        this.sidebarMinWidth = 72;
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    WarnAboutIE() {
      let ua = window.navigator.userAgent;
      let msie = ua.indexOf("MSIE "); // IE 10 or older
      let trident = ua.indexOf("Trident/"); //IE 11
      let isIE = msie > 0 || trident > 0;
      if (isIE) {
        if (document.cookie && document.cookie.includes("OkWithIE=true")) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isAdmin() {
      let user = this.accountUser;
      return user != null && user.admin;
    },
    isSponsor() {
      let user = this.accountUser;
      return user != null && user.sponsor;
    },
    isParticipant() {
      let user = this.accountUser;
      return user != null && user.participant;
    },
    calcMargin() {
      if (this.authenticated)
        return (
          (this.sidebarFull ? +this.sidebarFullWidth : this.sidebarMinWidth) +
          "px"
        );
      return "0px";
    },
    cssProps() {
      return {
        "--sidebar-width": this.calcMargin,
        "--sidebar-min-width": this.sidebarMinWidth + "px",
      };
    },
    onMultipleProjects() {
      return (
        this.accountUser &&
        this.accountUser.projectPermissions &&
        this.accountUser.projectPermissions.length > 1
      );
    },
    tenant() {
      return this.$store.getters.getTenantId;
    },
    appLogo() {
      let context = this.$store.getters.getContext;
      return context && context.logoUrl ? context.logoUrl : "";
    },
    canShowPopup(){
      return !this.$store.getters.getLoginPopup && this.tenant != null && this.authenticated && this.accountUser != null && this.accountUser.setup;
    },
    routerViewKey() {
      return this.$route.path.includes('/project/') ? 
        `/project/${this.$route.params.id}` :
        this.$route.path;
    },
  },
  watch: {
    user(newValue) {
      // Adds user to logrocket when vuex user changes
      // Primarily when user signs in or logged out then sign in again
      LogRocket.identify(newValue.userId, {
        name: newValue.name,
        email: this.user.email,

        // Custom LogRocket Variables
        admin: newValue.admin,
        participant: newValue.participant,
        setup: newValue.setup,
        sponsor: newValue.sponsor,
        systemAdmin: newValue.systemAdmin,
      });
    },
    authenticated() {
      if (this.canShowPopup) {
        this.loginPopupCheck();
      }
    },
    accountUser() {
      if (this.canShowPopup) {
        this.loginPopupCheck();
      }
    },
    tenant(val) {
      if (val && !this.$store.getters.getContext) {
        this.getContext(val);
      }
      if (this.canShowPopup) {
        this.loginPopupCheck();
      }
    }
  },
};
</script>

<style lang="scss">
.thumbnail {
  max-width: 100px;
}
html,
body {
  margin: 0;
  height: 100%;
}
.app-wrapper {
  margin-left: var(--sidebar-width);
}
.sidebar-wrapper {
  width: var(--sidebar-width);
}
.menu {
  &__mobile {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 72px;

    @media screen and (min-width: 768px) {
      display: none;
    }
  }
  &__desktop {
    @media screen and (max-width: 767px) {
      display: none;
    }
  }
}
</style>
